/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { RxRenewalSendMessageRequestContentItem } from "./RxRenewalSendMessageRequestContentItem";

export interface RxRenewalSendMessageRequest {
  type: "rx_renewal_selected_medication";
  content: RxRenewalSendMessageRequestContentItem[];
}
